
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("amtnj", function(module, exports) {
/* SpaceViewsList.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $6IL1T = parcelRequire("6IL1T");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $lfoFx = parcelRequire("lfoFx");

/**
 * @generated SignedSource<<8e21f15af30dff8ccaf7a6856e52b488>>
 * @relayHash bcb394b96be19bc640fe10988197d5b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ffa6cafb1c7ce3fd72dae9273247e701245d4c4d86a2f8fdb827bcc09fe7e2c
const $dbef08613cc1c425$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "folderId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "folderId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "after",
                            "variableName": "after"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasChildren"
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useFolderChildrenQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useFolderChildrenQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "bcb394b96be19bc640fe10988197d5b0",
            "id": "7ffa6cafb1c7ce3fd72dae9273247e701245d4c4d86a2f8fdb827bcc09fe7e2c",
            "metadata": {},
            "name": "useFolderChildrenQuery",
            "operationKind": "query",
            "text": "query useFolderChildrenQuery($folderId:ID!,$first:Int,$after:String){ptpage(id:$folderId,status:[CURRENT]){id,children(first:$first,after:$after){nodes{id,title,type,subType,hasChildren},pageInfo{endCursor,hasNextPage}}}}"
        }
    };
}();
$dbef08613cc1c425$var$node.hash = "f54094e3ae399b76ebda1f5dd806093d";
var $dbef08613cc1c425$export$2e2bcd8739ae039 = $dbef08613cc1c425$var$node;






var $jMyy4 = parcelRequire("jMyy4");

const $cbc14530709db83a$var$FOLDER_CHILDREN_PAGE_SIZE = 25;
const $cbc14530709db83a$export$4205aeb1cb362a3e = (folderId, shouldLoad)=>{
    const [isLoadingMore, setIsLoadingMore] = (0, $cozmU.useState)(false);
    const [loadMoreError, setLoadMoreError] = (0, $cozmU.useState)();
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)((0, $dbef08613cc1c425$export$2e2bcd8739ae039), {
        variables: {
            folderId: folderId,
            first: $cbc14530709db83a$var$FOLDER_CHILDREN_PAGE_SIZE
        },
        skip: !shouldLoad,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-first',
        __callerPackage__: "content-tree-search"
    });
    const pageInfo = data?.ptpage?.children?.pageInfo;
    const canLoadMore = Boolean(pageInfo?.hasNextPage && pageInfo.endCursor);
    const loadMore = (0, $cozmU.useCallback)(async ()=>{
        const endCursor = pageInfo?.endCursor;
        if (!endCursor || !canLoadMore || loading || isLoadingMore) return;
        setLoadMoreError(undefined);
        setIsLoadingMore(true);
        await fetchMore({
            variables: {
                after: endCursor
            },
            updateQuery: (previous, { fetchMoreResult: fetchMoreResult })=>{
                const previousPage = previous.ptpage?.children;
                const nextPage = fetchMoreResult?.ptpage?.children;
                if (!previous.ptpage || !previousPage || !nextPage) return previous;
                return {
                    ...previous,
                    ptpage: {
                        ...previous.ptpage,
                        children: {
                            ...nextPage,
                            nodes: [
                                ...previousPage.nodes ?? [],
                                ...nextPage.nodes ?? []
                            ]
                        }
                    }
                };
            }
        }).catch((fetchError)=>{
            setLoadMoreError(fetchError instanceof Error ? fetchError : new Error(String(fetchError)));
        }).finally(()=>{
            setIsLoadingMore(false);
        });
    }, [
        canLoadMore,
        fetchMore,
        isLoadingMore,
        loading,
        pageInfo?.endCursor
    ]);
    // On the render where `skip` flips to false, `useQueryInterop` still reports `loading: false`
    // with no data because its fetch effect has not run yet. Treat "expanded but nothing has come
    // back" as loading so consumers do not flash an empty state before the spinner appears.
    const hasResult = data !== undefined || error !== undefined;
    return {
        folderChildren: data?.ptpage?.children?.nodes?.filter((node)=>node !== null) ?? [],
        loading: shouldLoad && (!hasResult || loading && !data?.ptpage?.children),
        error: error ?? loadMoreError,
        isLoadingMore: isLoadingMore,
        loadMore: canLoadMore ? loadMore : undefined
    };
};



var $b3j2Y = parcelRequire("b3j2Y");


var $1NBp8 = parcelRequire("1NBp8");


var $lfFzM = parcelRequire("lfFzM");

/* SpaceViewsListItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");








var $3pCca = parcelRequire("3pCca");


var $1l0kj = parcelRequire("1l0kj");


var $dovdS = parcelRequire("dovdS");


var $huaOC = parcelRequire("huaOC");


var $d5um7 = parcelRequire("d5um7");

var $jZuGB = parcelRequire("jZuGB");

var $gMhPZ = parcelRequire("gMhPZ");


var $di8q4 = parcelRequire("di8q4");


var $2JGYp = parcelRequire("2JGYp");


var $4K4h4 = parcelRequire("4K4h4");


var $6bZDi = parcelRequire("6bZDi");


var $g0MxG = parcelRequire("g0MxG");


var $hXDOc = parcelRequire("hXDOc");

const $22798675b387cd1c$var$styles = {
    nav4EmojiWrapper: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _3YEZNOdnbC",
    title: "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7 _39HuIbz8Lp",
    contentIconWrapperNav4: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _3YEZNOdnbC",
    grid: "_0hPCNLDIqT _17lj8pgVvo _2iEGP2SWQi"
};
const $22798675b387cd1c$var$EmojiOrContentIcon = ({ isContentTreeIconVisible: isContentTreeIconVisible, contentType: contentType, subType: subType, iconColor: iconColor, displayEmoji: displayEmoji })=>{
    if (isContentTreeIconVisible && !displayEmoji) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $22798675b387cd1c$var$styles.contentIconWrapperNav4
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K4h4.ContentTreeIconLoader), {
        type: contentType,
        subType: subType,
        label: "",
        color: iconColor
    }));
    else if ((0, $2JGYp.isValidEmojiOrFavicon)(displayEmoji, contentType)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
        emoji: displayEmoji,
        height: 16,
        context: "spaceViews",
        wrapper: $22798675b387cd1c$var$Nav4EmojiWrapper,
        contentType: contentType
    });
    else return null;
};
const $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4 = {
    displayAndOpacity: "_0uw1WCYbGa _3AEWYUAEMG _2VmYgUQ4SZ _47e19BQ4SZ _1WpRJ1N91d _41F512N91d",
    isQuickActionsFocused: "_0uw1WCQ4SZ _3AEWYUN91d",
    isForceHoverBackground: "_0uw1WCQ4SZ _3AEWYUN91d"
};
const $22798675b387cd1c$var$Nav4EmojiWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        xcss: $22798675b387cd1c$var$styles.nav4EmojiWrapper
    }, children);
};
const $22798675b387cd1c$export$5cdf0e4af70a17cf = ({ title: title, url: url, onItemClick: onItemClick, isSelected: isSelected, item: item, displayEmoji: displayEmoji = '', contentType: contentType, spaceKey: spaceKey, isSuperAdmin: isSuperAdmin = false, closeAllHoverPageCards: closeAllHoverPageCards = ()=>{}, setOpenQuickActionsId: setOpenQuickActionsId, isQuickActionsOpen: isQuickActionsOpen, isQuickActionsFocused: isQuickActionsFocused, setFocusedQuickActionsId: setFocusedQuickActionsId, setIsEditingTitleId: setIsEditingTitleId, onEnterHoverTarget: onEnterHoverTarget = ()=>{}, onLeaveHoverTarget: onLeaveHoverTarget = ()=>{}, onBlurHoverTarget: onBlurHoverTarget = ()=>{}, shouldRenderAfterIcon: shouldRenderAfterIcon, index: index, renderTitle: renderTitle = ({ title: title })=>title, isExpanded: isExpanded, onExpansionToggle: onExpansionToggle, nestedContent: nestedContent })=>{
    const hoverPageCardTriggerRef = (0, $cozmU.useRef)(null);
    const onClick = (0, $cozmU.useCallback)(()=>{
        onItemClick && onItemClick(item.id, index);
        closeAllHoverPageCards();
    }, [
        onItemClick,
        item.id,
        index,
        closeAllHoverPageCards
    ]);
    const iconColor = isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined;
    const isContentTreeIconVisible = contentType && (0, $6bZDi.includesValidContentTreeType)(contentType);
    const isLiveDoc = contentType === 'page' && item.data.subType === 'live';
    const iconContentType = isLiveDoc ? 'liveDoc' : contentType;
    const menuItemContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $22798675b387cd1c$var$styles.grid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22798675b387cd1c$var$EmojiOrContentIcon, {
        isContentTreeIconVisible: isContentTreeIconVisible,
        contentType: iconContentType,
        subType: item.data.subType,
        iconColor: iconColor,
        displayEmoji: displayEmoji
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $22798675b387cd1c$var$styles.title
    }, renderTitle({
        title: title
    })));
    const elemAfter = shouldRenderAfterIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g0MxG.PageTreeAfterIconLoader), {
        setFocusedQuickActionsId: setFocusedQuickActionsId,
        isSuperAdmin: isSuperAdmin,
        isQuickActionsOpen: isQuickActionsOpen,
        setOpenQuickActionsId: setOpenQuickActionsId,
        setIsEditingTitleId: setIsEditingTitleId,
        closeAllHoverPageCards: closeAllHoverPageCards,
        spaceKey: spaceKey,
        item: item,
        displayTitle: title,
        hideFolder: true,
        disableRename: true
    });
    const hoverHandlers = {
        onBlur: onBlurHoverTarget,
        onMouseEnter: ()=>onEnterHoverTarget({
                itemID: item.id.toString(),
                isQuickActionsFocused: isQuickActionsFocused,
                hoverPageCardTriggerRef: hoverPageCardTriggerRef
            }),
        onMouseLeave: onLeaveHoverTarget,
        onFocus: ()=>onEnterHoverTarget({
                itemID: item.id.toString(),
                isQuickActionsFocused: isQuickActionsFocused,
                hoverPageCardTriggerRef: hoverPageCardTriggerRef
            })
    };
    if (onExpansionToggle && typeof isExpanded === 'boolean') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5um7.ExpandableMenuItem), {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: hoverPageCardTriggerRef,
        ...hoverHandlers,
        className: (0, $hekY6.default)([
            $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4.displayAndOpacity,
            isQuickActionsOpen && $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4.isForceHoverBackground,
            isQuickActionsFocused && $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4.isQuickActionsFocused
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
        name: "space-views-list-item",
        preloadUrl: url,
        preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gMhPZ.ExpandableMenuItemTrigger), {
        testId: "space-views-list-item",
        onClick: onClick,
        href: url,
        isSelected: isSelected,
        elemAfter: elemAfter
    }, menuItemContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jZuGB.ExpandableMenuItemContent), null, nestedContent)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: hoverPageCardTriggerRef,
        ...hoverHandlers,
        className: (0, $hekY6.default)([
            $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4.displayAndOpacity,
            isQuickActionsOpen && $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4.isForceHoverBackground,
            isQuickActionsFocused && $22798675b387cd1c$var$quickActionsMenuDisplayStylesNav4.isQuickActionsFocused
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
        name: "space-views-list-item",
        preloadUrl: url,
        preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huaOC.LinkMenuItem), {
        testId: "space-views-list-item",
        onClick: onClick,
        href: url,
        isSelected: isSelected,
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dovdS))), {
            label: ""
        }),
        elemAfter: elemAfter
    }, menuItemContent)));
};


const $1be42622e87811bc$var$styles = {
    resultState: "_4kiQYAnlTt _3iDTPbQ4SZ _0hPCNLDIqT _2Zuz6Q2ADO _1Znuxb2ADO"
};
const $1be42622e87811bc$var$FOLDER_LOADING_SPINNER_SIZE = 16;
const $1be42622e87811bc$var$ExpandableFolderSearchResult = ({ page: page, index: index, isNestedResult: isNestedResult, renderItem: renderItem, ...listProps })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { onFolderExpansionToggle: onFolderExpansionToggle } = listProps;
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const folderId = page.id?.split('/').pop() ?? '';
    const handleExpansionToggle = (0, $cozmU.useCallback)((nextIsExpanded)=>{
        setIsExpanded(nextIsExpanded);
        onFolderExpansionToggle?.({
            id: folderId,
            isExpanded: nextIsExpanded,
            index: index,
            isNested: isNestedResult
        });
    }, [
        folderId,
        index,
        isNestedResult,
        onFolderExpansionToggle
    ]);
    const { folderChildren: folderChildren, loading: loading, error: error, isLoadingMore: isLoadingMore, loadMore: loadMore } = (0, $cbc14530709db83a$export$4205aeb1cb362a3e)(folderId, isExpanded);
    const handleLoadMore = (0, $cozmU.useCallback)(()=>{
        loadMore?.();
    }, [
        loadMore
    ]);
    const nestedContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, folderChildren.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1be42622e87811bc$export$73023ca5401d91bc, {
        ...listProps,
        pagesList: folderChildren.map((child)=>({
                ...child,
                type: child.type ?? undefined,
                subType: child.subType ?? undefined
            })),
        enableFolderExpansion: true,
        isNested: true
    }) : null, isExpanded && loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $1be42622e87811bc$var$styles.resultState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: $1be42622e87811bc$var$FOLDER_LOADING_SPINNER_SIZE,
        label: intl.formatMessage($1be42622e87811bc$var$i18n.loadingFolder, {
            title: page.title
        }),
        testId: "folder-children-loading"
    })) : null, error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $1be42622e87811bc$var$styles.resultState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1be42622e87811bc$var$i18n.folderLoadError))))) : null, isExpanded && !loading && !error && folderChildren.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li",
        xcss: $1be42622e87811bc$var$styles.resultState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1be42622e87811bc$var$i18n.emptyFolder))) : null, loadMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handleLoadMore,
        isLoading: isLoadingMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $1be42622e87811bc$var$i18n.loadMore))) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderItem(page, index, nestedContent, isExpanded, handleExpansionToggle));
};
const $1be42622e87811bc$var$getUrlByType = (type)=>{
    const typeToUrl = {
        page: (0, $1NBp8.VIEW_PAGE),
        whiteboard: (0, $1NBp8.WHITEBOARD_BOARD),
        database: (0, $1NBp8.DATABASE_VIEW),
        slide: (0, $1NBp8.SLIDES_VIEW),
        embed: (0, $1NBp8.EMBED_VIEW),
        folder: (0, $1NBp8.FOLDER_VIEW)
    };
    return type && typeToUrl[type] ? typeToUrl[type] : (0, $1NBp8.VIEW_PAGE);
};
const $1be42622e87811bc$export$73023ca5401d91bc = ({ pagesList: pagesList, onItemClick: onItemClick, spaceKey: spaceKey, contentId: contentId, closeAllHoverPageCards: closeAllHoverPageCards = ()=>{}, onEnterHoverTarget: onEnterHoverTarget = ()=>{}, onLeaveHoverTarget: onLeaveHoverTarget = ()=>{}, onBlurHoverTarget: onBlurHoverTarget = ()=>{}, shouldRenderAfterIcon: shouldRenderAfterIcon, renderTitle: renderTitle = ({ title: title })=>title, enableFolderExpansion: enableFolderExpansion = false, isNested: isNested = false, onFolderExpansionToggle: onFolderExpansionToggle })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { isSuperAdmin: isSuperAdmin } = (0, $lfFzM.useIsSuperAdmin)();
    const [openQuickActionsId, setOpenQuickActionsId] = (0, $cozmU.useState)(null);
    const [focusedQuickActionsId, setFocusedQuickActionsId] = (0, $cozmU.useState)(null);
    const renderItem = (page, index, nestedContent, isExpanded, onExpansionToggle)=>{
        const { title: title, id: id, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions, displayEmoji: displayEmoji, type: type, subType: subType } = page;
        const isCurrentPage = Boolean(contentId && contentId === id);
        let parsedId = id; // databases, slides, embeds, and folders currently have their id returned as 'activation/ACTIVATION_ID/ENTITY_ID', so we are parsing the entity id
        if ((type === 'database' || type === 'embed' || type === 'slide' || type === 'folder') && id) parsedId = id.split('/').pop() || null;
        const contentLink = parsedId && spaceKey ? $1be42622e87811bc$var$getUrlByType(type).toUrl({
            spaceKey: spaceKey,
            contentId: parsedId
        }) : '';
        const item = {
            id: parsedId || '',
            hasRestrictions: hasRestrictions,
            hasInheritedRestrictions: hasInheritedRestrictions,
            data: {
                type: type,
                subType: subType
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22798675b387cd1c$export$5cdf0e4af70a17cf), {
            intl: intl,
            url: contentLink,
            title: title || ' ',
            displayEmoji: displayEmoji,
            contentType: type,
            onItemClick: onItemClick,
            key: id,
            index: index,
            isSelected: isCurrentPage,
            spaceKey: spaceKey || '',
            item: item,
            closeAllHoverPageCards: closeAllHoverPageCards,
            isSuperAdmin: isSuperAdmin,
            isQuickActionsOpen: openQuickActionsId === item.id,
            setOpenQuickActionsId: setOpenQuickActionsId,
            isQuickActionsFocused: focusedQuickActionsId === item.id,
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            setIsEditingTitleId: $1be42622e87811bc$var$noop,
            onEnterHoverTarget: onEnterHoverTarget,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            renderTitle: renderTitle,
            isExpanded: isExpanded,
            onExpansionToggle: onExpansionToggle,
            nestedContent: nestedContent
        });
    };
    const renderedItems = pagesList.map((page, index)=>{
        if (enableFolderExpansion && page.type === 'folder' && Boolean(page.id) && page.hasChildren !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1be42622e87811bc$var$ExpandableFolderSearchResult, {
            key: page.id,
            page: page,
            index: index,
            isNestedResult: isNested,
            renderItem: renderItem,
            onFolderExpansionToggle: onFolderExpansionToggle,
            onItemClick: onItemClick,
            spaceKey: spaceKey,
            contentId: contentId,
            closeAllHoverPageCards: closeAllHoverPageCards,
            onEnterHoverTarget: onEnterHoverTarget,
            onLeaveHoverTarget: onLeaveHoverTarget,
            onBlurHoverTarget: onBlurHoverTarget,
            shouldRenderAfterIcon: shouldRenderAfterIcon,
            renderTitle: renderTitle
        });
        return renderItem(page, index);
    });
    return isNested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderedItems) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), {
        role: "list"
    }, renderedItems));
};
const $1be42622e87811bc$var$noop = ()=>Promise.resolve();
const $1be42622e87811bc$var$i18n = (0, $kSwu1.defineMessages)({
    loadingFolder: {
        id: "space-views.content-tree-search.folder.loading",
        defaultMessage: "Loading content in {title}"
    },
    folderLoadError: {
        id: "space-views.content-tree-search.folder.load-error",
        defaultMessage: "We couldn\u2019t load this folder\u2019s content."
    },
    emptyFolder: {
        id: "space-views.content-tree-search.folder.empty",
        defaultMessage: "There\u2019s nothing in this folder yet"
    },
    loadMore: {
        id: "space-views.content-tree-search.folder.load-more",
        defaultMessage: "Show more"
    }
});
module.exports["SpaceViewsList"] = $1be42622e87811bc$export$73023ca5401d91bc;

});

parcelRegister("g0MxG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ab7921964510845f$export$e3668039106e3bc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "CQdGh",
    name: "PageTreeAfterIconLoader",
    loader: async ()=>(await (parcelRequire("eIS7X"))).PageTreeAfterIcon
});
module.exports["PageTreeAfterIconLoader"] = $ab7921964510845f$export$e3668039106e3bc;

});

parcelRegister("eIS7X", function(module, exports) {

let $ab7f2950d3fd9ece$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ab7f2950d3fd9ece$var$load("hsRa9"),
    $ab7f2950d3fd9ece$var$load("bEleE"),
    $ab7f2950d3fd9ece$var$load("6wr18"),
    $ab7f2950d3fd9ece$var$load("gUrlb"),
    $ab7f2950d3fd9ece$var$load("ffEVr"),
    $ab7f2950d3fd9ece$var$load("5gsbh"),
    $ab7f2950d3fd9ece$var$load("8OeKT"),
    $ab7f2950d3fd9ece$var$load("dkv9z")
]).then(()=>parcelRequire('4Nj9v'));

});

parcelRegister("lY1lm", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cd81aae1dd865317$export$56ef5168f507b51a = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6xpDa",
    name: "TreeMonitorLoader",
    loader: async ()=>(await (parcelRequire("g2aIc"))).TreeMonitor
});
module.exports["TreeMonitorLoader"] = $cd81aae1dd865317$export$56ef5168f507b51a;

});

parcelRegister("g2aIc", function(module, exports) {

let $bac5246dc63f4126$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bac5246dc63f4126$var$load("cBeoH"),
    $bac5246dc63f4126$var$load("lN9TX"),
    $bac5246dc63f4126$var$load("abBST"),
    $bac5246dc63f4126$var$load("Tjs4D"),
    $bac5246dc63f4126$var$load("f9QHk")
]).then(()=>parcelRequire('e14IX'));

});


//# sourceMappingURL=SpaceViewsList.f5ef10bb.js.map
